import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-kpi-request-revert-list',
  templateUrl: './kpi-request-revert-list.component.html',
  styleUrls: ['./kpi-request-revert-list.component.css']
})
export class KpiRequestRevertListComponent implements OnInit {
  constructor(private AdviceService: ServiceService, private route: ActivatedRoute, private router: Router ,private _snackBar: MatSnackBar) { }
  output: any = [];
  loaderShown = true;
  tableShown = false;
  count = 0;
  New_count = 0
  next_output: any = [];
  data = {
    _id: "",
    approve: false,
    status: ""
  }

  updateStatus(id:any,value: any) {
    console.log(value)
    this.data.approve = true
    this.data._id = id
     if (value == 1) {
      this.data.status = "Approved"
    }
    if (value == 2) {
      this.data.status = "Rejected"
    }
    this.AdviceService.updateKpiRevertRequest(this.data).subscribe((res) => {
      console.log("response=", res)
      this._snackBar.open(res.message);
      this.ngOnInit();

      //  this.ngOnInit();
    })
  }
  //---function for click previous----------
  clicks_previous() {
    if (this.New_count == 0) {
      return;
    }
    else {
      this.New_count = this.New_count - 1;
      this.count = this.New_count;
    }
    this.AdviceService.viewKpiRevertRequest('offset='+this.count).subscribe((res) => {
      this.output = res.data
    })

  }
  //-------function for click next-------
  clicks_next() {
    this.count = this.count + 1
    this.AdviceService.viewKpiRevertRequest('offset='+this.count).subscribe((res) => {
      this.next_output = res.data
      if (this.next_output.length != 0) {
        this.output = this.next_output;
        this.New_count = this.count;
      }
    })
  }
  //-------date formating-------------

  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe: any = null;

  DateFormat(value: any) {
    //-------date formating----------------------
    // this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y');

    return this.todayWithPipe
  }
  DateandtimeFormat(value: any) {
    //-------date formating----------------------
    // this.todayWithPipe = this.pipe.transform(value, 'MMM d, y');
    this.todayWithPipe = this.pipe.transform(value, 'h:mm:ss a');
    // this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');

    return this.todayWithPipe
  }
  ngOnInit(): void {
    this.AdviceService.viewKpiRevertRequest(this.count).subscribe((res) => {
      console.log("res", res)
      this.output = res.data
      this.next_output = res.data
      this.loaderShown = false;
      this.tableShown = true;

    })
  }

}


